import { Component, h } from 'preact';

import { ReqState } from '../../../../../types/request-state.model';

import { InqPropertyCard } from '../propcard/inq-property-card.component';
import { ViewingList, ViewingListMetadata } from '../../../../../types/inquiries/viewing-list.model';
import { Listing } from '../../../../../types/listing.model';
import { hopplerApi } from '../../../../../constants';
import { Inquiry } from '../../../../../types/inquiries';

interface VlFinalListPanelProps {
  inquiry: Inquiry;
  viewingList: ViewingList;
  vlSaveState?: ReqState;

  onPanelClose: () => void;
  onSave: () => void;
  onScheduleViewing: () => void;

  onRemoveListing: (listing: Listing) => void;
  onListingProgressUpdate: (listing: Listing, progress: string) => void;
}
interface VlFinalListPanelState {}

export class VlFinalListPanel extends Component<VlFinalListPanelProps, VlFinalListPanelState> {
  getCardList() {
    const viewingList = this.props.viewingList;
    const finalList = viewingList.finalList;

    const statuses: { [k: string]: string } = {};
    const statusKeys = finalList.statusKeys || [];
    statusKeys.forEach(sk => statuses[sk.key] = sk.status);

    return (
      finalList.results.map(listing => {
        return <InqPropertyCard listing={ listing }
          onRemoveFromListClick={ this.props.onRemoveListing }
          inFinalList={ true }
          progressStatus={ statuses[listing.propertyKey] }
          onProgressUpdate={ progress => this.props.onListingProgressUpdate(listing, progress) } />
      })
    );
  }

  getDownloadButton() {
    const { inquiry, viewingList } = this.props;
    const meta = viewingList.viewingList;
    const url = `${hopplerApi.host}/kumita/inquiry/${inquiry.inquiryCode}/viewing-lists/${meta.vlKey}/download`
    const vlIsSaved = !!meta.vlKey;

    if (vlIsSaved) {
      return (
        <a href={ url } className="btn btn-outline-dark hi-vlmfinlist__download-button"
          target="_blank">
          Download
        </a>
      );
    } else {
      return (
        <button className="btn btn-outline-dark hi-vlmfinlist__download-button" disabled>
          Download
        </button>
      );
    }
    
  }

  getShareLinkButton() {
    const { inquiry, viewingList } = this.props;
    const url = `/vl/${inquiry.inquiryKey}/${viewingList.viewingList.vlKey}`;
    const vlIsSaved = !!viewingList.viewingList.vlKey;

    if (vlIsSaved) {
      return (
        <a href={ url } className="btn btn-outline-dark hi-vlmfinlist__share-button"
          target="_blank" rel="noopener">
          Share Link
        </a>
      );
    } else {
      return (
        <button className="btn btn-outline-dark hi-vlmfinlist__share-button" disabled>
          Share Link
        </button>
      );
    }
    
  }

  getSaveButton() {
    if (this.props.vlSaveState === ReqState.IN_PROGRESS) {
      return (
        <button className="btn btn-secondary hi-vlmfinlist__save-button" disabled={ true }>
          <i className="fas fa-circle-notch fa-spin" /> Saving...
        </button>
      );
    } else {
      return (
        <button className="btn btn-secondary hi-vlmfinlist__save-button" onClick={ this.props.onSave }>
          Save
        </button>
      );
    }
  }

  render() {
    const props = this.props;
    const viewingList = props.viewingList;
    const finalList = viewingList.finalList;
    const vlIsSaved = !!viewingList.viewingList.vlKey;
    
    return (
      <div className="hi-vlmfinlist">
        <div className="hi-vlmfinlist__title-bar">
          <button className="btn btn-link hi-vlmfinlist__title-back" onClick={ this.props.onPanelClose }>
            <i className="fas fa-arrow-left" />
          </button>

          <span className="hi-vlmfinlist__title">
            { !vlIsSaved ? 'Unsaved ' : '' } Viewing List
          </span>

          <button className="btn btn-link hi-vlmfinlist__title-schedule" onClick={ this.props.onScheduleViewing }>
            <i className="far fa-calendar-alt" /> Schedule
          </button>
        </div>

        <div className="hi-vlmfinlist__card-list">
          <p className="hi-vlmfinlist__card-list-note">
            <strong>Note:</strong> This will remain under Made 1st Call until
            scheduled for viewing. Once scheduled, it will be moved under 
            Viewings Scheduled.
          </p>

          {/* Cards go here! */}
          { this.getCardList() }
        </div>

        <div className="hi-vlmfinlist__bottom-buttons">
          { this.getDownloadButton() }
          { this.getShareLinkButton() }
          { this.getSaveButton() }
        </div>
      </div>
    );
  }
}